import { createSlice } from "@reduxjs/toolkit";

export const pendingWashesFiltersSlice = createSlice({
    name: 'pendingWashesFilters',
    initialState: {
        searchVal: '',
        filters: {
            lotId: { value: null },
        },
    },
    reducers: {
        setSearchVal: (state, action) => {
            state.searchVal = action.payload;
        },
        setFilters: (state, action) => {
            state.filters = action.payload;
        }
    },
});

export const { setSearchVal, setFilters } = pendingWashesFiltersSlice.actions;
export default pendingWashesFiltersSlice.reducer;
